import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(`/_authenticated/delete-confirmed`)({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/delete-confirmed"!</div>
}
